import Base from './base'
import { Account } from '../types/account'

export type UserAccount = {
  id: number
  name: string
  active: boolean
}

export default class Accounts extends Base {
  async visible(): Promise<Account[]> {
    return this.api.get('accounts/visible.json')
  }

  async getTiers(): Promise<{ id: number; name: string }[]> {
    try {
      const response = await this.api.get('account_tiers.json', {
        params: { per_page: 100, sort_by: 'order', sort_direction: 'ASC' },
      })
      return Array.isArray(response) ? response : response?.data ?? []
    } catch {
      return []
    }
  }

  async getUserAccounts(): Promise<UserAccount[]> {
    try {
      const response = await this.api.get('accounts/user_accounts')
      return Array.isArray(response) ? response : response?.data ?? []
    } catch {
      return []
    }
  }
}
